export const ACTIVE_RULE = "ACTIVE_RULE";
export const CREATE_FIELD_RULE = "CREATE_FIELD_RULE";
export const GET_FIELD_RULE = "GET_FIELD_RULE";
export const SET_PROJECT = "SET_PROJECT";


